<template>
  <div class="editContainer">
    <div
      class="modal-content d-flex flex-row"
      id="cont-ainer"
      style="border: solid 1px #ccc"
    >
      <div
        id="jsmindContainer"
        ref="jsmindContainer"
        class="jsmind-container"
      ></div>
      <div class="d-flex modalUndo">
        <!-- <span @click="handleUndo" class="modalIcon">
          <v-icon size="20"> panda-undo</v-icon>
        </span> -->
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span class="mindMapBtn mr-3" v-on="on" v-bind="attrs">
              <span @click="handleUndo" class="modalIcon">
                <v-icon size="20"> panda-undo</v-icon>
              </span>
            </span>
          </template>
          <span>{{ $t('message.ai.abstract.undo') }} </span>
        </v-tooltip>
      </div>

      <div class="d-flex modalIcons">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-on="on"
              v-bind="attrs"
              @click="handleZoomToFit"
              class="modalIcon"
            >
              <img class="custom-svg" src="@/assets/centralizeIcon.svg"
            /></span>
          </template>
          <span>{{ $t('message.ai.mindmap.centralize') }} </span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-on="on"
              v-bind="attrs"
              @click="handleZoomOut"
              class="modalIcon"
              :class="{ 'disabled-icon': isZoomOutDisabled }"
              :disabled="isZoomOutDisabled"
            >
              <img class="custom-svg" src="@/assets/zoomOut.svg" />
            </span>
          </template>
          <span>{{ $t('message.ai.mindmap.reduce') }} </span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-on="on"
              v-bind="attrs"
              @click="handleZoomIn"
              class="modalIcon"
              :class="{ 'disabled-icon': isZoomInDisabled }"
              :disabled="isZoomInDisabled"
            >
              <img class="custom-svg" src="@/assets/zoomIn.svg" />
            </span>
          </template>
          <span>{{ $t('message.ai.mindmap.amplify') }} </span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import Storage from '@/utils/Storage'
import aiWorkflowApi from '@/services/aiworkflowApi.js'
export default {
  name: 'MindmapEditor',
  data: () => ({
    jsmind_data: {
      meta: {
        name: 'jsMind',
        author: 'Panda Video',
        version: '0.8.1',
      },
      format: 'node_tree',
      data: {},
    },
    diagramLoaded: false,
    jsMind: null,
    jm: null,
    editedMindMapData: null,
    isZoomInDisabled: false,
    isZoomOutDisabled: false,
    rootColor: '#2980b9',
    usedColors: [],
    undoStack: [],
    redoStack: [],
    colorPalette: [
      '#db34ac',
      '#2ecc71',
      '#9b59b6',
      '#34495e',
      '#f1c40f',
      '#e67e22',
      '#e74c3c',
      '#95a5a6',
      '#7f8c8d',
      '#d35400',
      '#c0392b',
      '#8e44ad',
      '#3fdb34',
      '#1abc9c',
    ],
  }),
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
  async mounted() {
    await this.loadJsMindScript()
    this.initJsMind()
    this.addBtnAnimation()
    this.saveState()
    this.$root.$on('saveEditedMindmap', () => {
      this.saveEditedMindmap()
    })
    this.$root.$on('handleDiscardChanges', () => {
      this.handleDiscardChanges()
    })
  },
  beforeDestroy() {
    this.$root.$off('saveEditedMindmap')
    this.$root.$off('handleDiscardChanges')
  },
  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.dark
    },
  },
  methods: {
    modifyMapExample() {
      this.saveState()
      this.jm.add_node('root_1', 'newNode', 'Novo Nó')
    },
    saveState() {
      const currentState = JSON.parse(JSON.stringify(this.jm.get_data()))
      this.undoStack.push(currentState)
      this.redoStack = []
    },
    handleUndo() {
      if (this.undoStack.length > 0) {
        const currentState = JSON.parse(JSON.stringify(this.jm.get_data()))
        this.redoStack.push(currentState)

        const lastState = this.undoStack.pop()
        this.jm.show(lastState)

        // Reaplicar os eventos de hover e botões
        this.handleNodeHover()
      }
    },
    handleRedo() {
      if (this.redoStack.length > 0) {
        const currentState = JSON.parse(JSON.stringify(this.jm.get_data()))
        this.undoStack.push(currentState)

        const nextState = this.redoStack.pop()
        this.jm.show(nextState)
      }
    },
    async loadJsMindScript() {
      try {
        const jsmindScriptSrc =
          'https://cdn.jsdelivr.net/npm/jsmind/es6/jsmind.js'
        const draggableNodeScriptSrc =
          'https://cdn.jsdelivr.net/npm/jsmind/es6/jsmind.draggable-node.js'

        const styleSheetHref =
          'https://cdn.jsdelivr.net/npm/jsmind/style/jsmind.css'

        const loadScript = (src) =>
          new Promise((resolve, reject) => {
            const script = document.createElement('script')
            script.src = src
            script.onload = () => resolve(`Script loaded successfully: ${src}`)
            script.onerror = () =>
              reject(new Error(`Script loading error: ${src}`))
            document.head.appendChild(script)
          })

        const loadStyleSheet = (href) =>
          new Promise((resolve, reject) => {
            const link = document.createElement('link')
            link.rel = 'stylesheet'
            link.href = href
            link.onload = () =>
              resolve(`Stylesheet loaded successfully: ${href}`)
            link.onerror = () =>
              reject(new Error(`Stylesheet loading error: ${href}`))
            document.head.appendChild(link)
          })

        await loadScript(jsmindScriptSrc)
        await loadScript(draggableNodeScriptSrc)
        await loadStyleSheet(styleSheetHref)
      } catch (error) {
        console.error('JsMind script loading error:', error)
      }
    },

    initJsMind() {
      this.jsMind = window.jsMind
      const jsmind_options = {
        editable: true,
        theme: 'orange',
        container: this.$refs.jsmindContainer,
        view: {
          zoom: {
            max: 5,
            min: 0.05,
            step: 0.1,
          },
          draggable: true,
        },
      }
      this.jm = new this.jsMind(jsmind_options)
      this.renderJsMindMap()
      this.forceZoomOut()
    },
    renderJsMindMap() {
      const key = 'mindmapString'
      const mindmapString = JSON.parse(Storage.getItem(key))
      const jsMindData = this.convertToJsMind(mindmapString)
      this.jsmind_data.data = jsMindData
      this.jm.show(this.jsmind_data)
      this.handleNodeHover()
    },
    convertToJsMind(
      data,
      parentId = 'root',
      nodeId = 1,
      direction = 'right',
      currentColor = this.colorPalette[0],
      rootLevel = true
    ) {
      const nodeColor = parentId === 'root' ? this.rootColor : currentColor
      const node = {
        id: `${parentId}_${nodeId}`,
        topic: data.text || data.theme || ' ',
        children: [],
        direction: direction,
        'background-color': nodeColor,
      }
      this.usedColors.push(nodeColor)

      if (!data.children || data.children.length === 0) {
        return node
      }

      const half = Math.ceil(data.children.length / 2)
      let nextColorIndex = 0

      data.children.forEach((child, index) => {
        const childDirection =
          parentId === 'root' ? (index < half ? 'left' : 'right') : direction
        let childColor = currentColor
        if (rootLevel) {
          childColor =
            this.colorPalette[nextColorIndex % this.colorPalette.length]
          nextColorIndex++
        }
        const childNode = this.convertToJsMind(
          child,
          node.id,
          index + 1,
          childDirection,
          childColor,
          false
        )
        node.children.push(childNode)
      })

      return node
    },
    saveEditedMindmap() {
      this.$root.$emit('loadingSaveButton', true)
      this.editedMindMapData = this.jm.get_data().data
      const convertedMindMap = this.convertMindmap(this.editedMindMapData)
      this.updateMindmapData(this.videoId, convertedMindMap)
    },
    convertMindmap(originalNode) {
      const newNode =
        originalNode.id === 'root_1'
          ? { theme: originalNode.topic, children: [] }
          : { text: originalNode.topic, children: [] }

      if (originalNode.children && originalNode.children.length > 0) {
        originalNode.children.forEach((child) => {
          newNode.children.push(this.convertMindmap(child))
        })
      }

      return newNode
    },
    async updateMindmapData(videoId, myConvertedModel) {
      const data = {
        video_id: videoId,
        mindmap: myConvertedModel,
      }
      try {
        await aiWorkflowApi.updateAiWorkFlowData(data)
        const jsonModel = JSON.stringify(myConvertedModel)
        this.addMindmapToLocalStorage(jsonModel)
        this.$root.$emit('renderDiagram', myConvertedModel)
        this.$root.$emit('loadingSaveButton', false)
      } catch (error) {
        console.error(error)
      }
    },
    addMindmapToLocalStorage(val) {
      const key = 'mindmapString'
      Storage.setItem(key, val)
    },
    handleDiscardChanges() {
      this.renderJsMindMap()
    },
    handleZoomIn() {
      this.isZoomOutDisabled = false
      this.jm.view.zoom_in()
    },
    handleZoomOut() {
      this.isZoomInDisabled = false
      this.jm.view.zoom_current = this.jm.view.zoom_current - 0.2
      this.jm.view.zoom_in()
    },
    forceZoomOut() {
      for (let i = 0; i < 5; i++) {
        this.handleZoomOut()
      }
    },
    handleZoomToFit() {
      // this.forceZoomOut()
      const node = this.jm.get_node('root_1')
      this.jm.view.center_node(node)
    },
    createButtonContainer() {
      const container = document.createElement('div')
      container.classList.add('node-action-buttons')
      container.style.cssText = `
        position: absolute;
        display: block;
        z-index: 10;
        text-align: center;
      `
      return container
    },
    positionButtonContainer(container, nodeElement, direction, centerOffset) {
      const top = parseInt(nodeElement.style.top, 10)
      const left = parseInt(nodeElement.style.left, 10)
      container.style.top = `${top + centerOffset}px`

      if (direction === -1) {
        container.style.left = `${left - 40}px`
      } else if (direction === 1) {
        container.style.left = `${left + 190}px`
      }
    },
    addButtonToContainer(container, buttonHtml) {
      container.innerHTML = buttonHtml
    },
    insertButtonContainer(nodeElement, container) {
      nodeElement.parentNode.insertBefore(container, nodeElement.nextSibling)
    },
    addButtonsToNode(nodeId, node) {
      const nodeElement = document.querySelector(`jmnode[nodeid="${nodeId}"]`)
      if (!nodeElement) return

      let buttonsContainer = this.createButtonContainer()

      if (node.isroot) {
        const leftButtonContainer = this.createButtonContainer()
        const rightButtonContainer = this.createButtonContainer()

        this.addButtonToContainer(
          leftButtonContainer,
          this.addNodeButtonHtml(nodeId, true, 'left')
        )
        this.addButtonToContainer(
          rightButtonContainer,
          this.addNodeButtonHtml(nodeId, true, 'right')
        )

        this.insertButtonContainer(nodeElement, leftButtonContainer)
        this.insertButtonContainer(nodeElement, rightButtonContainer)

        const { height } = nodeElement.getBoundingClientRect()
        const centerBtn = Math.round(height) / 2 - 25
        this.positionButtonContainer(
          leftButtonContainer,
          nodeElement,
          -1,
          centerBtn
        )
        this.positionButtonContainer(
          rightButtonContainer,
          nodeElement,
          1,
          centerBtn
        )
      } else {
        this.addButtonToContainer(
          buttonsContainer,
          this.addNodeButtonHtml(nodeId)
        )
        this.insertButtonContainer(nodeElement, buttonsContainer)
        const { height } = nodeElement.getBoundingClientRect()
        const centerBtn = Math.round(height) / 2 - 25
        this.positionButtonContainer(
          buttonsContainer,
          nodeElement,
          node.direction,
          centerBtn
        )
      }
    },
    addNodeButtonHtml(nodeId, isRoot, direction) {
      const className = 'is-root' + '-' + direction
      const rootClass = isRoot ? className : ''
      const buttonId = isRoot ? nodeId + '-' + direction : nodeId
      const button = `
        <button
          class="primary ${rootClass} hvr-bounce-in addNodeBtn"
          id="${buttonId}"
          role="button"
          @click="addNodeBtnAction"
          style="
            color: #ffffff;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: #4c43cd;
            background-image:
              radial-gradient(
                93% 87% at 87% 89%,
                rgba(0, 0, 0, 0.23) 0%,
                transparent 86.18%
              ),
              radial-gradient(
                66% 87% at 26% 20%,
                rgba(255, 255, 255, 0.41) 0%,
                rgba(255, 255, 255, 0) 69.79%,
                rgba(255, 255, 255, 0) 100%
              );
            box-shadow: 2px 19px 31px rgba(0, 0, 0, 0.2);
            font-weight: bold;
            font-size: 32px;
            border: 0;
            user-select: none;
            -webkit-user-select: none;
            touch-action: manipulation;
            visibility: visible;
            cursor: pointer;
          "
        >+</button>`
      return button
    },
    handleNodeHover() {
      const _this = this
      const nodeElements = document.querySelectorAll('jmnode') // Selecionar todos os nós

      nodeElements.forEach((node) => {
        node.removeEventListener('mouseenter', this.showBtn) // Remove eventos antigos
        node.removeEventListener('mouseleave', this.hideBtn) // Remove eventos antigos

        node.addEventListener('mouseenter', function (event) {
          _this.showBtn(event)
        })
        node.addEventListener('mouseleave', function () {
          _this.hideBtn()
        })
      })
    },
    handleNewNodeHover(node) {
      const _this = this

      node.addEventListener('mouseenter', function (event) {
        _this.showBtn(event)
      })
      node.addEventListener('mouseleave', function () {
        _this.hideBtn()
      })
    },
    hideBtn() {
      const elements = document.getElementsByClassName('node-action-buttons')
      const elementsArray = Array.from(elements)

      this.timeoutId = setTimeout(() => {
        elementsArray.forEach((div) => {
          div.remove()
        })
      }, 50)
    },
    showBtn(event) {
      const nodeElement = event.target
      const nodeId = nodeElement.getAttribute('nodeid')
      const _node = this.jm.mind.nodes[nodeId]

      if (!_node) return // Evitar erros se o nó não existir

      this.addButtonsToNode(nodeId, _node) // Recriar os botões de ação
      this.handleHoverAddNodeBtn() // Garantir que os eventos de hover sejam aplicados aos botões
    },
    handleHoverAddNodeBtn() {
      const _this = this
      const btnElements = document.querySelectorAll('.node-action-buttons')
      btnElements.forEach((btn) => {
        btn.addEventListener('mouseenter', function () {
          clearTimeout(_this.timeoutId)
        })
        btn.addEventListener('mouseleave', function () {
          _this.hideBtn()
        })
        btn.addEventListener('click', function (e) {
          const btn = e.target
          const btnId = btn.getAttribute('id')
          const parentNodeId =
            btnId.includes('left') || btnId.includes('right') ? 'root_1' : btnId

          _this.jm.select_node(parentNodeId)

          const selected_node = _this.jm.get_selected_node()
          const isRoot = selected_node.isroot
          const nextNodeId = _this.generateNextNodeId(
            _this.jm.mind.nodes,
            parentNodeId
          )
          const topic = ' '
          if (isRoot) {
            const nextNodeDir = btnId.includes('left') ? 'left' : 'right'
            _this.addNodeBtnAction(
              selected_node,
              nextNodeId,
              topic,
              nextNodeDir
            )
          } else {
            _this.addNodeBtnAction(selected_node, nextNodeId, topic)
          }
        })
      })
    },
    addNodeBtnAction(selected_node, nodeid, topic, direction) {
      this.saveState() // Salva o estado antes da modificação
      const isRoot = selected_node.isroot
      const parentNodeColor = selected_node.data['background-color']
      const newNodeColor = isRoot ? this.sortNewNodeColor() : parentNodeColor
      const data = { 'background-color': newNodeColor }

      this.jm.add_node(selected_node, nodeid, topic, data, direction)
      const newNode = document.querySelector(`jmnode[nodeid="${nodeid}"]`)
      this.handleNewNodeHover(newNode)
    },
    deleteNodeAction(nodeId) {
      this.saveState() // Salva o estado antes da exclusão
      this.jm.remove_node(nodeId)
    },
    generateNextNodeId(nodes, parentId) {
      const childNodeIds = Object.keys(nodes).filter((nodeId) => {
        return (
          nodeId.startsWith(parentId + '_') &&
          nodeId.match(/_/g).length === parentId.match(/_/g).length + 1
        )
      })

      let maxSuffix = 0
      childNodeIds.forEach((nodeId) => {
        const currentSuffix = parseInt(nodeId.split('_').pop(), 10)
        if (currentSuffix > maxSuffix) {
          maxSuffix = currentSuffix
        }
      })

      const nextNodeId = `${parentId}_${maxSuffix + 1}`
      return nextNodeId
    },
    sortNewNodeColor() {
      const newColor = this.colorPalette.find(
        (color) => !this.usedColors.includes(color)
      )
      this.usedColors.push(newColor)
      return newColor
    },
    addBtnAnimation() {
      const style = document.createElement('style')

      style.textContent = `
        .hvr-bounce-in {
          display: inline-block;
          vertical-align: middle;
          -webkit-transform: perspective(1px) translateZ(0);
          transform: perspective(1px) translateZ(0);
          box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          -webkit-transition-duration: 1.5s;
          transition-duration: 1.5s;
        }
        .hvr-bounce-in:hover, .hvr-bounce-in:focus, .hvr-bounce-in:active {
          -webkit-transform: scale(1.2);
          transform: scale(1.2);
          -webkit-transition-timing-function: cubic-bezier(0.47, 2.02, 0.31, -0.36);
          transition-timing-function: cubic-bezier(0.47, 2.02, 0.31, -0.36);
        }
        .addNodeBtn:active {
          background-color: #000000;
          color: #000000;
          transform: translateY(8px);
          transition-duration: 0.1s;
          -webkit-transform: perspective(1px) translateZ(0);
          transform: perspective(1px) translateZ(0);
          box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          -webkit-transition-duration: 0.1s;
          transition-duration: 0.1s;
        }
      `
      document.head.appendChild(style)
    },
  },
}
</script>
<style scoped lang="scss">
.editContainer {
  border-top: 1px solid varFigma(neutral-95-lightest);
  background: #f9f9fb;
}

@media (max-width: 760px) {
  .editContainer {
    height: 700px;
  }
}

.bg-dark {
  .custom-svg {
    filter: brightness(0) saturate(100%) invert(81%) sepia(7%) saturate(280%)
      hue-rotate(193deg) brightness(93%) contrast(90%);
  }
}

.modalIcon.disabled-icon {
  background: varFigma(neutral-95-lightest);
  cursor: not-allowed;
  pointer-events: none; /* Impede cliques em ícones desabilitados */
}

.modalIcons {
  position: absolute;
  top: 90px;
  right: 8px;
  z-index: 999;
}

.modalUndo {
  position: absolute;
  top: 90px;
  left: 16px;
  z-index: 999;
}

.modalIcon {
  align-content: center;
  justify-content: center;
  padding: 10px;
  margin-right: 8px;
  border-radius: var(--spacing-03, 8px);
  background: varFigma(neutral-100-white);
  cursor: pointer;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
}

.modalIcon:hover {
  background: varFigma(neutral-95-lightest);
}

::v-deep .jsmind-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 62vh;
  .jsmind-inner {
    overflow: hidden;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  jmnode {
    width: 200px;
    min-height: 30px;
    padding: 10px;
    box-sizing: border-box;
    word-wrap: break-word;
    white-space: normal;
    margin: auto;
    text-align: center;
  }
  jmnodes.theme-orange jmnode.selected {
    border: solid 1px #000000;
  }
}
.modal-content {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  cursor: grab;
}
.modal-content:active {
  cursor: grabbing;
}
</style>
